/* Moments Etched v15.4.7.12 — Step 5 savings-tier confirmation + customer-facing neck label footer */
(() => {
  const INTERNAL_NECK_PLACEMENT = 'Custom Neck Label';
  const QUOTE_MIN = 21;

  const quantity = (root) => [...root.querySelectorAll('[data-me-size-quantity]')]
    .reduce((sum, input) => sum + Math.max(0, parseInt(input.value || '0', 10) || 0), 0);

  const neckMode = (root) => String(
    root?.dataset?.meNeckLabelMode ||
    root?.querySelector?.('[data-me-neck-label-choice]:checked')?.value ||
    'original'
  );

  const neckLabel = (root) => {
    const mode = neckMode(root);
    if (mode === 'me-branding') return 'Moments Etched Label';
    if (mode === 'custom') return 'Your Brand Label';
    return 'Neck Label';
  };

  const syncNeckFooterLabel = (root) => {
    const internal = root.querySelector('[data-me-preview-placement-label]');
    if (!internal) return;
    const placement = String(internal.textContent || '').trim();
    if (placement === INTERNAL_NECK_PLACEMENT) {
      const label = neckLabel(root);
      internal.dataset.meCustomerPlacementLabel = label;
      internal.setAttribute('aria-label', label);
    } else {
      delete internal.dataset.meCustomerPlacementLabel;
      internal.removeAttribute('aria-label');
    }
  };

  const setTierCopy = (tier) => {
    const value = Number(tier.dataset.tier || 0);
    const small = tier.querySelector('small');
    if (!small) return;
    if (value === 6) small.textContent = 'Save 5%';
    if (value === 11) small.textContent = 'Save 10%';
    if (value === 21) small.textContent = 'Custom bulk pricing';
  };

  const syncSavings = (root) => {
    const pricing = root.querySelector('[data-me-volume-pricing]');
    if (!pricing) return;

    const qty = quantity(root);
    const tiers = [...pricing.querySelectorAll('[data-tier]')];
    const quoteMode = qty >= QUOTE_MIN;
    const currentEarned = quoteMode ? 0 : qty >= 11 ? 11 : qty >= 6 ? 6 : 0;

    tiers.forEach((tier) => {
      const value = Number(tier.dataset.tier || 0);
      const earned = !quoteMode && ((value === 6 && qty >= 6) || (value === 11 && qty >= 11));
      const current = earned && value === currentEarned;
      const quoteCurrent = value === QUOTE_MIN && quoteMode;

      tier.classList.toggle('me-tier-earned', earned);
      tier.classList.toggle('me-tier-current', current);
      tier.classList.toggle('me-tier-quote-current', quoteCurrent);
      setTierCopy(tier);

      if (current || quoteCurrent) tier.setAttribute('aria-current', 'true');
      else tier.removeAttribute('aria-current');

      if (value === 6) {
        tier.setAttribute('aria-label', '6 to 10 items. Save 5 percent.');
      } else if (value === 11) {
        tier.setAttribute('aria-label', '11 to 20 items. Save 10 percent.');
      } else if (value === QUOTE_MIN) {
        tier.setAttribute('aria-label', '21 or more items. Custom bulk pricing requires a managed quote.');
      }
    });

    pricing.classList.toggle('me-volume-pricing--tier-reached', qty >= 6 && qty < QUOTE_MIN);
    pricing.classList.toggle('me-volume-pricing--quote-reached', quoteMode);

    const message = pricing.querySelector('[data-me-volume-message]');
    if (message) {
      message.classList.toggle('me-volume-message--reached', qty >= 6 && qty < QUOTE_MIN);
      message.classList.toggle('me-volume-message--quote', quoteMode);
      if (quoteMode) {
        message.textContent = '✓ 21+ bulk pricing available. Submit a quote request for final pricing based on your order details.';
      } else if (qty >= 11) {
        message.textContent = '✓ 10% group savings tier reached.';
      } else if (qty >= 6) {
        message.textContent = '✓ 5% group savings tier reached.';
      } else {
        message.textContent = 'Order 6 or more to unlock group savings.';
      }
    }
  };

  const syncRoot = (root) => {
    if (!root) return;
    syncSavings(root);
    syncNeckFooterLabel(root);
  };

  const bindRoot = (root) => {
    if (!root || root.dataset.meV154712Bound === 'true') {
      syncRoot(root);
      return;
    }
    root.dataset.meV154712Bound = 'true';

    root.addEventListener('input', (event) => {
      if (event.target?.matches?.('[data-me-size-quantity]')) requestAnimationFrame(() => syncSavings(root));
    });
    root.addEventListener('change', (event) => {
      if (event.target?.matches?.('[data-me-size-quantity], [data-me-neck-label-choice]')) {
        requestAnimationFrame(() => syncRoot(root));
      }
    });

    const placementLabel = root.querySelector('[data-me-preview-placement-label]');
    if (placementLabel) {
      new MutationObserver(() => requestAnimationFrame(() => syncNeckFooterLabel(root)))
        .observe(placementLabel, { childList: true, characterData: true, subtree: true });
    }

    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => ['data-me-studio-stage', 'data-me-neck-label-mode'].includes(mutation.attributeName))) {
        requestAnimationFrame(() => syncRoot(root));
      }
    }).observe(root, { attributes: true, attributeFilter: ['data-me-studio-stage', 'data-me-neck-label-mode'] });

    syncRoot(root);
  };

  const init = () => document.querySelectorAll('[data-me-designer]').forEach(bindRoot);

  window.addEventListener('me:neck-label-updated', () => requestAnimationFrame(init));
  window.addEventListener('me:placements-updated', () => requestAnimationFrame(init));
  window.addEventListener('me:preview-placement', () => requestAnimationFrame(() => requestAnimationFrame(init)));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
